//@flow
//Action Type Registered
export const HERMES_INV_SUBMIT_SUCCESS='HERMES_INV_SUBMIT_SUCCESS';
export const HERMES_INV_SUBMIT_ERROR='HERMES_INV_SUBMIT_ERROR';
export const HERMES_INV_SUBMITTED_COMPLETED='HERMES_INV_SUBMITTED_COMPLETED';
export const HERMES_EDIT_VERIFY_FORM_DATA_SUCCESS='HERMES_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const HERMES_EDIT_VERIFY_FORM_DATA_ERROR='HERMES_EDIT_VERIFY_FORM_DATA_ERROR'
export const HERMES_UPDATE_FORM_ERROR='HERMES_UPDATE_FORM_ERROR'
export const REFRESH_HERMES_VENDORS_SUCCESS='REFRESH_HERMES_VENDORS_SUCCESS';
export const REFRESH_HERMES_VENDORS_ERROR='REFRESH_HERMES_VENDORS_ERROR';


// WEBPACK FOOTER //
// ./src/redux/hermes/actionTypes.js